import { ApiClient } from '../../http/api_client';

export class UserReviewRefineSearchRepository {
  async getUserReviewRefineSearchHtml(url: string) {
    return ApiClient.get(url, { responseType: "document" });
  }
}
